import { render, staticRenderFns } from "./NotificationWalletShareInvite.vue?vue&type=template&id=7950ed27"
import script from "./NotificationWalletShareInvite.vue?vue&type=script&lang=js"
export * from "./NotificationWalletShareInvite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports